import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import '../styling/PastProjects.css';

function PastProjects() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const projectsData = [
    {
      name: "Payora",
      category: "Fintech Super App",
      description: "A comprehensive fintech platform providing wallet services, bill payments, virtual accounts and cards with secure backend and mobile experience.",
      image: "/images/payora.png",
      stack: ["React Native", "Django", "MySQL", "AWS", "Kora"],
      links: [
        { label: "Google Play", url: "https://play.google.com/store/apps/details?id=com.supervas.cyberdatahub" },
        { label: "App Store", url: "https://apps.apple.com/ng/app/cyber-data-hub/id6467631238" }
      ],
      featured: true
    },
    {
      name: "MediOrganizer",
      category: "Healthcare App",
      description: "A smart medication tracker designed for people with chronic kidney disease (CKD) and anemia. Stay organized with medication management, timely reminders, and easy-to-understand health information.",
      image: "/images/mediorganizer.png",
      stack: ["React Native", "Healthcare", "Medication Tracking", "Reminders"],
      links: [
        { label: "Google Play", url: "https://play.google.com/store/apps/details?id=care.medice.companion&pcampaignid=web_share" },
        { label: "App Store", url: "https://apps.apple.com/bs/app/mediorganizer/id6698892887" }
      ],
      featured: true
    },
    {
      name: "Upscale Patterns",
      category: "Mobile App",
      description: "Convert Half-Scale Sewing Patterns to Full-Scale Fast & Easy! A mobile application for seamstresses and designers.",
      image: "/images/Nusize.png",
      stack: ["React Native", "Expo", "Javascript", "Django", "Python"],
      links: [
        { label: "Google Play", url: "https://play.google.com/store/apps/details?id=com.bcimageapp" },
        { label: "App Store", url: "https://apps.apple.com/us/app/nu-size-sewing-pattern/id6483004797" }
      ]
    },
    {
      name: "Coiled Hair",
      category: "Marketplace",
      description: "EMPOWER individuals with textured hair to confidently DISCOVER products that align with their UNIQUE hair care NEEDS, HEALTH priorities, and personal VALUES.",
      image: "/images/coiledhair.png",
      stack: ["Mobile App", "Product Matching", "E-commerce", "React Native"],
      links: [
        { label: "Visit Site", url: "https://coiledhairapp.com" }
      ]
    },
    {
      name: "Kn1ght",
      category: "Mobile App",
      description: "Create Short Videos from text using Kn1ght animation! Transform your text content into engaging short-form videos.",
      image: "/images/Kn1ghts.png",
      stack: ["React Native", "Expo", "Javascript", "Animation"],
      links: [
        { label: "Google Play", url: "https://play.google.com/store/apps/details?id=com.kn1ghts" },
        { label: "App Store", url: "https://apps.apple.com/app/id6470290408" }
      ]
    },
    {
      name: "MyMedicalBank",
      category: "Healthcare",
      description: "Nigeria's first Personal Health Record App, available for Android and iOS devices. Store and manage your medical records securely.",
      image: "/images/mymedicalbank.png",
      stack: ["React Native", "Expo", "Javascript", "Axios", "Healthcare"],
      links: [
        { label: "Google Play", url: "https://play.google.com/store/apps/details?id=com.mymedicalbankphr" },
        { label: "App Store", url: "https://apps.apple.com/ng/app/mymedicalbank/id6464156472" }
      ]
    },
    {
      name: "Tech Hive",
      category: "Community Platform",
      description: "Co-founded with Michael Olu, Tech Hive fosters a dynamic tech community based in Port Harcourt, Nigeria, with 100+ members.",
      image: "/images/techhive.png",
      stack: ["Django", "Python", "React", "Bootstrap"],
      links: [
        { label: "Visit Site", url: "https://techhive.ng" }
      ]
    },
    {
      name: "My Portfolio V3",
      category: "Personal Website",
      description: "My personal portfolio, a single-page website featuring extensive use of React and Bootstrap. Clean, modern design showcasing my work.",
      image: "/images/myportfolio.png",
      stack: ["React", "Bootstrap", "Javascript", "HTML/CSS"],
      links: [
        { label: "Visit Site", url: "https://justrobin.dev" }
      ]
    }
  ];

  const nextProject = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % projectsData.length);
  };

  const prevProject = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + projectsData.length) % projectsData.length);
  };

  const goToProject = (index) => {
    setCurrentIndex(index);
  };

  const currentProject = projectsData[currentIndex];

  return (
    <section className="projects-section">
      <Container className="projects-container">
        {/* Header */}
        <div className="projects-header">
          <span className="section-accent">Portfolio</span>
          <h2 className="section-title">
            Featured <span className="title-highlight">Projects</span>
          </h2>
          <p className="section-subtitle">
            Production-ready applications and platforms built for real users
          </p>
          <div className="title-underline"></div>
        </div>

        {/* Project Showcase */}
        <div className="project-showcase">
          <div className="showcase-content">
            {/* Project Image */}
            <div className="project-image-section">
              <div className="project-image-wrapper">
                <img 
                  src={currentProject.image} 
                  alt={currentProject.name}
                  className="project-image"
                />
                {currentProject.featured && (
                  <div className="featured-badge">⭐ Featured</div>
                )}
              </div>
            </div>

            {/* Project Details */}
            <div className="project-details-section">
              <div className="project-header">
                <span className="project-category">{currentProject.category}</span>
                <h3 className="project-name">{currentProject.name}</h3>
              </div>

              <p className="project-description">
                {currentProject.description}
              </p>

              {/* Tech Stack */}
              <div className="tech-stack">
                <h4 className="stack-title">Tech Stack</h4>
                <div className="stack-tags">
                  {currentProject.stack.map((tech, idx) => (
                    <span key={idx} className="stack-tag">{tech}</span>
                  ))}
                </div>
              </div>

              {/* Links */}
              <div className="project-links">
                {currentProject.links.map((link, idx) => (
                  <a
                    key={idx}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                  >
                    <span className="link-icon">🔗</span>
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Navigation Controls */}
          <div className="showcase-controls">
            <button 
              className="nav-btn prev-btn"
              onClick={prevProject}
              aria-label="Previous project"
            >
              ←
            </button>
            <button 
              className="nav-btn next-btn"
              onClick={nextProject}
              aria-label="Next project"
            >
              →
            </button>
          </div>
        </div>

        {/* Project Indicators */}
        <div className="project-indicators">
          {projectsData.map((project, idx) => (
            <button
              key={idx}
              className={`indicator ${idx === currentIndex ? 'active' : ''}`}
              onClick={() => goToProject(idx)}
              aria-label={`Go to ${project.name}`}
              title={project.name}
            >
              <span className="indicator-label">{project.name}</span>
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        {/* <div className="projects-grid">
          <h3 className="grid-title">All Projects</h3>
          <div className="grid-container">
            {projectsData.map((project, idx) => (
              <div 
                key={idx}
                className={`project-card ${project.featured ? 'featured' : ''}`}
                onClick={() => goToProject(idx)}
              >
                <div className="card-image-wrapper">
                  <img 
                    src={project.image}
                    alt={project.name}
                    className="card-image"
                  />
                  {project.featured && (
                    <div className="card-featured-badge">⭐</div>
                  )}
                </div>

                <div className="card-content">
                  <p className="card-category">{project.category}</p>
                  <h4 className="card-name">{project.name}</h4>
                  <p className="card-description">{project.description}</p>
                  
                  <div className="card-tech">
                    {project.stack.slice(0, 2).map((tech, idx) => (
                      <span key={idx} className="card-tech-tag">{tech}</span>
                    ))}
                    {project.stack.length > 2 && (
                      <span className="card-tech-tag">+{project.stack.length - 2}</span>
                    )}
                  </div>
                </div>

                <div className="card-overlay">
                  <span className="view-text">View Details</span>
                </div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Summary */}
        <div className="projects-summary">
          <div className="summary-stat">
            <div className="stat-number">{projectsData.length}</div>
            <div className="stat-label">Projects</div>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-stat">
            <div className="stat-number">{projectsData.filter(p => p.featured).length}</div>
            <div className="stat-label">Featured</div>
          </div>
          <div className="summary-divider"></div>
          <div className="summary-stat">
            <div className="stat-number">100%</div>
            <div className="stat-label">Live & Active</div>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default PastProjects;